<template>
	<div class="vedio_main vedio_wish_item">
      <audio :src="audioSrc" class="bAudio" ref="bAudio"></audio>
      <a href="javascript:;" class="play_btn" @click="audioPlay"></a>
      <div class="vedio_progress">
        <div class="progress_all">
          <div class="progress_play" :style="progress"></div>
        </div>
        <div class="times" v-if="playing">
          <span class="play_time_count">{{currentTime}}</span>
         <span class="vedio_all_time">{{durationTime}}</span>
        </div>
      </div>
      <home :ishome=0></home>
    </div>
</template>
<script>
	import home from '../common/home.vue'
	export default {
		props:{
			audioSrc:String
		},	
		data(){
			return {
				progress:{
					width:'0%',
				},
				currentTime:'00:00',
				durationTime:'00:00',
				playing:false
			}
		},
		components:{
    		home
 		},
		computed:{
			bAudio(){
				return this.$refs.bAudio;
			}
		},
		methods:{
			audioPlay(event){
				if(event.target.classList.contains('play')){
					event.target.classList.remove('play');
					this.bAudio.pause();
				}else{
					event.target.classList.add('play');
					this.bAudio.play();
					console.log("audioduration",this.bAudio.duration)
					if(this.bAudio.duration){
						this.currentTime=this.bAudio.currentTime<=59?(this.bAudio.currentTime/100).toFixed(2):'01:00';
						this.durationTime=this.bAudio.duration<=59?(this.bAudio.duration/100).toFixed(2):'01:00';
						this.playing=true;
						var interval = setInterval(()=> {
							var widthline = Math.round(this.bAudio.currentTime)/Math.round(this.bAudio.duration) * 100;
							this.currentTime=this.bAudio.currentTime<=59?(this.bAudio.currentTime/100).toFixed(2):'01:00';
							this.progress.width = widthline + "%";
							if(widthline>=100){
								clearInterval(interval);
								event.target.classList.remove('play');
							}
						},500);
					}
				}
			},
			isWX(){
	          var ua = window.navigator.userAgent.toLowerCase();
	          return ua.indexOf('micromessenger') !== -1;
	        },
	        waudioPlay(){
	          this.bAudio.play();
	          this.bAudio.pause();
	        }
		},
		mounted(){
			if (this.isWX()) {
	          document.addEventListener("WeixinJSBridgeReady", this.waudioPlay, false);
	          document.addEventListener('YixinJSBridgeReady', this.waudioPlay, false);
	        }
		}
	}
</script>